import { render } from "./InformationBar.vue?vue&type=template&id=a44d81be&scoped=true"
import script from "./InformationBar.vue?vue&type=script&lang=js"
export * from "./InformationBar.vue?vue&type=script&lang=js"

import "./InformationBar.vue?vue&type=style&index=0&id=a44d81be&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44d81be"]])

export default __exports__